import React, { useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const ClientsSection = () => {
  // States to hold references to our custom navigation buttons
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  const logos = [
    { id: 1, name: 'Gensol', url: '/images/client-1.png' },
    { id: 2, name: 'Moke', url: '/images/client-2.png' },
    { id: 3, name: 'Marcopolo',url: '/images/client-3.png'},
    { id: 4, name: 'Neuton Auto', url: '/images/client-4.png'},
    { id: 5, name: 'Blue Energy', url: '/images/client-5.png' },
    { id: 6, name: 'Sun Mobility', url: '/images/client-6.png' },
    { id: 7, name: 'BHarat Forge', url: '/images/client-7.png' },
    { id: 8, name: 'Tork Electrics', url: '/images/client-8.png' },
  ];

  return (
    <section className="relative w-full bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-6xl mx-auto relative">
        
        {/* --- Header Section (Heading + Top Right Controls) --- */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 border-b border-slate-200 pb-5">
          <div>
     <span className="text-sm font-semibold text-cogCyan block mb-3">
           Our Network
          </span>
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Proudly Serving Industry Leaders 
            </h2>
          </div>

          {/* Custom Navigation Arrows shifted to Top Right */}
          <div className="flex items-center gap-2 mt-4 sm:mt-0">
            <button
              ref={(node) => setPrevEl(node)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition-all hover:bg-blue-600 hover:text-white hover:border-blue-600 active:scale-95 disabled:opacity-40 disabled:pointer-events-none shadow-sm"
              aria-label="Previous slide"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              ref={(node) => setNextEl(node)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition-all hover:bg-blue-600 hover:text-white hover:border-blue-600 active:scale-95 disabled:opacity-40 disabled:pointer-events-none shadow-sm"
              aria-label="Next slide"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* --- Swiper Container with Edge Fades --- */}
        <div className="relative w-full">
          {/* Edge Fades (Gradients masking extreme left & right) */}
          {/* Note: matching from-slate-50 to the section background colour ensures a seamless blend */}
          <div className="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-16 bg-gradient-to-r from-slate-50 to-transparent sm:w-28" />
          <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-16 bg-gradient-to-l from-slate-50 to-transparent sm:w-28" />

          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={24}
            slidesPerView={2}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            // Link custom state refs to Swiper's navigation config
            navigation={{
              prevEl,
              nextEl,
            }}
            breakpoints={{
              640: { slidesPerView: 3, spaceBetween: 32 },
              768: { slidesPerView: 4, spaceBetween: 40 },
              1024: { slidesPerView: 5, spaceBetween: 48 },
            }}
            className="!pb-14 [--swiper-pagination-color:#2563eb]"
          >
            {logos.map((logo) => (
              <SwiperSlide key={logo.id}>
                <div className="flex h-24 items-center justify-center  p-6 transition-all duration-300 hover:shadow-md hover:border-slate-200">
                  <img
                    src={logo.url}
                    alt={`${logo.name} logo`}
                    className="max-h-20 max-w-full object-contain opaciy-60 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

      </div>
    </section>
  );
};

export default ClientsSection;